
import PropTypes from 'prop-types'

export default function FormBtn(props){
    return(
        <button className={`form-btn ${props.className}${props.disabled ? " disabled" : ""}`} disabled={props.disabled !== undefined ? props.disabled : false}>{props.disabled !== undefined && props.disabled ? props.disableText : props.text}</button>
    )
}

FormBtn.propTypes = {
    text: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    disableText: PropTypes.string
}